// extracted by mini-css-extract-plugin
module.exports = {"heading":"_PersonalisedLinks_heading__3N3qO","list":"_PersonalisedLinks_list__3uuVf"};